(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4093],{

/***/ 64093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content046": function() { return /* binding */ Content046; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_RichTextWidget__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14258);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87900);
/* harmony import */ var _Content046_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41533);
/* harmony import */ var _Content046_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Content046_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var Content046 = function(param) {
    var payload = param.payload;
    var ref, ref1, ref2;
    var ref3;
    var title = (ref3 = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref3 !== void 0 ? ref3 : "";
    var ref4;
    var description = (ref4 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref4 !== void 0 ? ref4 : "";
    var ref5;
    var appearance = (ref5 = payload === null || payload === void 0 ? void 0 : payload.template) !== null && ref5 !== void 0 ? ref5 : "light";
    var ref6;
    var buttonText = (ref6 = payload === null || payload === void 0 ? void 0 : (ref = payload.button) === null || ref === void 0 ? void 0 : ref.buttonText) !== null && ref6 !== void 0 ? ref6 : "";
    var ref7;
    var link = (ref7 = payload === null || payload === void 0 ? void 0 : (ref1 = payload.button) === null || ref1 === void 0 ? void 0 : ref1.link) !== null && ref7 !== void 0 ? ref7 : "";
    var ref8;
    var target = (ref8 = payload === null || payload === void 0 ? void 0 : (ref2 = payload.button) === null || ref2 === void 0 ? void 0 : ref2.target) !== null && ref8 !== void 0 ? ref8 : "_blank";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (_Content046_module_scss__WEBPACK_IMPORTED_MODULE_5___default().background), appearance === "light")),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Content046_module_scss__WEBPACK_IMPORTED_MODULE_5___default().block), (_Content046_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[appearance]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .PageLink */ .H_, {
                        link: link,
                        className: (_Content046_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link),
                        target: target,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_Content046_module_scss__WEBPACK_IMPORTED_MODULE_5___default().arrow),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
                                    className: (_Content046_module_scss__WEBPACK_IMPORTED_MODULE_5___default().icon),
                                    name: "large_arrow_right"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .Paragraph */ .nv, {
                                color: appearance === "light" ? "brand" : "light",
                                appearance: "bigger",
                                className: (_Content046_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["button-text"]),
                                children: buttonText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Content046_module_scss__WEBPACK_IMPORTED_MODULE_5___default().text),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .Heading3 */ .aC, {
                                className: (_Content046_module_scss__WEBPACK_IMPORTED_MODULE_5___default().title),
                                color: "dark",
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RichTextWidget__WEBPACK_IMPORTED_MODULE_2__/* .RichText */ .H, {
                                value: description,
                                className: (_Content046_module_scss__WEBPACK_IMPORTED_MODULE_5___default().description)
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content046);


/***/ }),

/***/ 41533:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"block":"Content046_block__V8ca4","background":"Content046_background__mTJge","text":"Content046_text__JzjbM","title":"Content046_title__OIska","description":"Content046_description__HEm9D","link":"Content046_link__D64JX","arrow":"Content046_arrow__zBZ92","icon":"Content046_icon__q92md","button-text":"Content046_button-text__UJsCZ","light":"Content046_light__cNLWy","dark":"Content046_dark__1_YE0"};

/***/ })

}]);